/**
 * Constantes pour l'application Mawered — multi-pays
 */

// Conservé pour compatibilité ascendante avec les composants existants
export const TUNISIA_DEFAULTS = {
    currency: 'TND',
    locale: 'fr-TN',
    country: 'TN',
    timezone: 'Africa/Tunis',
    dateFormat: 'dd/MM/yyyy',
    workingHoursPerWeek: 40,
    workingDaysPerWeek: 6,
    workingHoursPerDay: 8,
    annualLeaveDays: 26,
    sickLeaveDays: 15,
    maternityLeaveDays: 98,
    paternityLeaveDays: 3,
    numberFormat: {
        decimal: ',',
        thousands: ' ',
        precision: 3
    }
};

// Configuration multi-devises
export const CURRENCY_CONFIG = {
    TND: { symbol: 'DT',  name: 'Dinar Tunisien',   code: 'TND', locale: 'fr-TN', decimals: 3 },
    EUR: { symbol: '€',   name: 'Euro',              code: 'EUR', locale: 'fr-FR', decimals: 2 },
    MAD: { symbol: 'MAD', name: 'Dirham Marocain',   code: 'MAD', locale: 'fr-MA', decimals: 2 },
    QAR: { symbol: 'QAR', name: 'Riyal Qatarien',    code: 'QAR', locale: 'ar-QA', decimals: 2 },
    SAR: { symbol: 'SAR', name: 'Riyal Saoudien',    code: 'SAR', locale: 'ar-SA', decimals: 2 },
    USD: { symbol: '$',   name: 'Dollar US',          code: 'USD', locale: 'en-US', decimals: 2 },
};

// Defaults par pays — source de vérité statique côté frontend (utilisée avant le chargement de l'API)
export const COUNTRY_DEFAULTS = {
    TN: { currency: 'TND', timezone: 'Africa/Tunis',     locale: 'fr-TN', dialCode: '+216', flag: '🇹🇳', nameFr: 'Tunisie' },
    QA: { currency: 'QAR', timezone: 'Asia/Qatar',       locale: 'ar-QA', dialCode: '+974', flag: '🇶🇦', nameFr: 'Qatar'   },
    MA: { currency: 'MAD', timezone: 'Africa/Casablanca', locale: 'fr-MA', dialCode: '+212', flag: '🇲🇦', nameFr: 'Maroc'   },
    FR: { currency: 'EUR', timezone: 'Europe/Paris',     locale: 'fr-FR', dialCode: '+33',  flag: '🇫🇷', nameFr: 'France'  },
    SA: { currency: 'SAR', timezone: 'Asia/Riyadh',      locale: 'ar-SA', dialCode: '+966', flag: '🇸🇦', nameFr: 'Arabie Saoudite' },
};

// Configuration des formats d'affichage
export const DISPLAY_FORMATS = {
    COMPACT_THRESHOLD: 1000,
    MILLION_THRESHOLD: 1000000,
    DECIMAL_PLACES: 1
};

// Valeurs par défaut globales
export const DEFAULT_VALUES = {
    currency: 'TND',
    locale: 'fr-TN',
    amount: 0,
    country: 'TN'
};

const constants = {
    TUNISIA_DEFAULTS,
    CURRENCY_CONFIG,
    COUNTRY_DEFAULTS,
    DISPLAY_FORMATS,
    DEFAULT_VALUES
};

export default constants;
